import { CommonModule } from '@angular/common';
import { CoreUiSharedModule } from '../template/core-ui-shared.module';

//component list
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SideBarItems } from './sidebar/sidebar-items';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';

const components: Array<Type<unknown>> = [
  AuthLayoutComponent,
  MainLayoutComponent,
  HeaderComponent,
  SidebarComponent,
  HeaderComponent,
];

@NgModule({
  declarations: [
    ...components,
  ],
  imports: [
    CommonModule,
    CoreUiSharedModule,
    NgbModule,
  ],
  exports: [
    ...components,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [SideBarItems],
})
export class LayoutModule {}
